import { FC, } from "react";
import { Button, Col } from "reactstrap";
import { MakeOfferPriceTitle, ScheduleTestDriverTitle } from "../../../../constants";
import { useAppDispatch } from "../../../../reduxToolkit/hooks";
import { setDriverModal, setOfferModal } from "../../../../reduxToolkit/reducers/layoutSlice";
import { CarDetailType } from "../../../../types/Product";
import DriverModal from "../../modals/DriverModal";
import OfferModal from "../../modals/OfferModal";
import ContactInfo from "./ContactInfo";
import Exploration from "./Exploration";
import FeaturedProperty from "./FeaturedProperty";
import Apply from "./Apply";
import OtherOpportunities from "./OtherOpportunities";
import ApplyForJob from "./ApplyForJob";
import KeyJobDetails from "./KeyJobDetails";
import SimilarJobs from "./SimilarJobs";
import ShareFriends from "../../gridView/rightSidebar/ShareFriends";

const DetailSidebar: FC<CarDetailType> = ({ type, sliderStyle }) => {
  const dispatch = useAppDispatch();

  return (
    <>
      {type === "car" ? (
        <>
          <Col lg="3">
            <div className="car-detail-sidebar">
              <div className="sidebar-box">
                <Button className="btn-solid" onClick={() => dispatch(setDriverModal())}>
                  <i className="ri-steering-2-line" /> {ScheduleTestDriverTitle}
                </Button>
                <Button className="btn-border" onClick={() => dispatch(setOfferModal())}>
                  <i className="ri-price-tag-3-line" /> {MakeOfferPriceTitle}
                </Button>
              </div>
              <div className="sidebar-box">
                <div className="detail-sub-sidebar">
                  <ContactInfo type={type} />
                  <Exploration type={type} />
                </div>
              </div>
              <div className="sidebar-box">
                <FeaturedProperty type={type} />
              </div>
            </div>
          </Col>
          <DriverModal />
          <OfferModal />
        </>
      ) : type === "job" ? (
        <Col lg={sliderStyle === "style_3" ? "5" : "4"} className={sliderStyle === "style_2" || sliderStyle === "style_5" ? "col-xl-3" : ""}>
          <div className={`detail-right-sidebar ${sliderStyle === "style_4" ? "similar-sidebar" : ""}`}>
            {sliderStyle === "style_2" || sliderStyle === "style_5" ? (
              <>
                <ApplyForJob />
                <OtherOpportunities />
                <ShareFriends />
              </>
            ) : sliderStyle === "style_3" ? (
              <>
                <KeyJobDetails />
              </>
            ) : sliderStyle === "style_4" ? (
              <>
                <SimilarJobs />
              </>
            ) : (
              <>
                <Apply />
                <OtherOpportunities />
              </>
            )}
          </div>
        </Col>
      ) : (
        <Col xl="3" lg="4">
          <div className="detail-sidebar">
            <div className="detail-sub-sidebar">
              <ContactInfo />
              <Exploration />
            </div>
            <FeaturedProperty type={type} />
          </div>
        </Col>
      )}
    </>
  );
};

export default DetailSidebar;
